import "./shortcuts.scss";

import React from "react";
import { Link } from "react-router-dom";

import { Icon, Typography } from "@/components/Elements";

export type Shortcut = {
  to: string;
  text: string;
};

type Props = {
  shortcuts: Shortcut[];
};

export default function Shortcuts(props: Props) {
  return (
    <div className="shortcuts">
      <Typography label="Shortcuts" color="generalMidnightDark" size="md" />
      <div className="shortcuts-list">
        {props.shortcuts.map((shortcut) => (
          <Link to={shortcut.to} key={shortcut.text} className="shortcut">
            <Typography label={shortcut.text} color="generalWhite" size="sm" />
            <Icon name="chevronRight" color="generalWhite" />
          </Link>
        ))}
      </div>
    </div>
  );
}
